import { render, staticRenderFns } from "./remain-cash.vue?vue&type=template&id=545115e5&scoped=true"
import script from "./remain-cash.vue?vue&type=script&lang=js"
export * from "./remain-cash.vue?vue&type=script&lang=js"
import style0 from "./remain-cash.vue?vue&type=style&index=0&id=545115e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545115e5",
  null
  
)

export default component.exports